<div class="d-flex flex-column mx-2 px-4 py-2 h-100 cx-one-ui">
    <!-- Header -->
    <div class="d-flex align-items-end justify-content-between border-bottom managementHeader" aria-labelledby="manageDashboardsHeader">
        <h1 class="text-nowrap managementHeaderText" role="heading" cvLocalizedText langSection="Dashboards_Landing" langKey="Manage_Dashboards"
            aria-level="1" id="manageDashboardsHeader" data-qa="cxone-manage-dashboard-header-title"> 
            Manage Dashboards
        </h1>

        <div #createDropdown="ngbDropdown" ngbDropdown>
            <button type="button" class="btn header-btn ml-0 mt-3 sub-menu-button" *ngIf="hasCreatePermission" [disabled]="!canCreateNewDashboard()" ngbDropdownToggle>
                <span cvLocalizedText style="margin-right: 16px;" langSection="Dashboards_Landing" langKey="Create_Dashboard">Create Dashboard</span>
                <svg class="icon-12 dropdown-menu-icon arrow-margin">
                    <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
                </svg>
            </button>
            <ul ngbDropdownMenu>
                <li ngbDropdownItem>
                    <button type="button" class="btn dropdown-menu-item" (click)="openNewDashboardDialog()" *ngIf="hasCreatePermission" 
                        cvLocalizedText langSection="Dashboards_Landing" langKey="New">New
                    </button>
                </li>
                <li ngbDropdownItem>
                    <button type="button" class="btn dropdown-menu-item" (click)="openFromTemplate()" *ngIf="hasCreatePermission" 
                        cvLocalizedText langSection="Dashboards_Landing" langKey="From_Template">From Template
                    </button>
                </li>
            </ul>
        </div>  
    </div>

    <!-- Main -->
    <main class="managementBody">
        <nav class="tabGroup">
            <ul class="nav nav-tabs" role="tablist" aria-controls="dashboardCount">
                <li class="nav-item">
                    <a [ngClass]="{'active': favoritesOnly}" (click)="favoritesOnly = true" href="#!" aria-label="Favorite dashboards"
                        cvLocalizedAttrs="aria-label" langSection="Dashboards_Landing" langKey="Favorite_Dashboards">
                        <svg class="icon-16 fill-favoriteYellow mb-1 mr-1">
                            <use href="../App_Themes/CXone/icons/favorite-star.svg#favorite-star"></use>
                        </svg>
                        {{ getLocalizationString('Favorites', 'Favorites').toUpperCase() }}
                    </a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="{'active': !favoritesOnly}" (click)="favoritesOnly = false" href="#!" aria-label="All dashboards"
                        cvLocalizedAttrs="aria-label" langSection="Dashboards_Landing" langKey="All_Dashboards">
                        {{ getLocalizationString('All', 'All').toUpperCase() }}
                    </a>
                </li>
            </ul>
        </nav>
        <div class="d-flex flex-grow-1" style="min-height: 0;">
            <!-- Dashboard List -->
            <div class="d-flex flex-column col p-0">
                <!-- Search bar and New Dashboard button -->
                <div class="d-flex mt-3 pb-3 mb-1 align-items-center dashboardHeader" role="status" aria-live="polite" id="dashboardCount">
                    <div class="mr-4 ml-4" style="min-width: 100px; max-width: max-content" *ngIf="numGridRows !== 1" tabindex="0"> 
                        {{ getLocalizationString('Dashboards_Plural', numGridRows + ' dashboards', numGridRows) }} 
                    </div>
                    <div class="mr-4 ml-4" style="min-width: 100px; max-width: max-content" *ngIf="numGridRows === 1" tabindex="0">
                        {{ getLocalizationString('Dashboards_Singular', numGridRows + ' dashboard', numGridRows) }} 
                    </div>
                    <!--Search-->
                    <div class="cxone-live-search">
                        <cxone-text-input
                            type="search"
                            autocomplete="off"
                            class="cxone-dashboard-search"
                            [placeholder]="getLocalizationString('Find_Dashboards', 'Start typing to find dashboards')"
                            [(ngModel)]="this.filterValue"
                            (ngModelChangeDebounced)="filterValue"
                            [ngModelChangeDebounceTime]="500">
                        </cxone-text-input>
                        <i class="icon-search" [hidden]="filterValue.length !== 0">
                            <svg class="icon-18 fill-iconDefault-noHover search-wrapper">
                                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                            </svg>
                        </i>
                        <i class="icon-search" [hidden]="filterValue.length === 0" (click)="filterValue = ''">
                            <svg class="icon-18 fill-iconDefault-noHover close-wrapper">
                                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                            </svg>
                        </i>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex">
                        <cv-manage-available-dashboards
                            *ngIf="showGrid" class="flex-fill cxoneDashboardsGrid" [allowManagement]="true"
                            [multiSelect]="false" [toolbar]="false" [favoritesFilter]="favoritesOnly" [minSearchLength]="2"
                            [showCurrentlyOpen]="showCurrentlyOpen" [columns]="columns" [allCapsHeaders]="true"
                            [searchFilter]="filterValue" [isCXOne]="true" (selectionChanged)="selectedDashboards = $event"
                            (copyClicked)="openCopyDialog()" (editDetailsClicked)="openEditDetailsDialog()"
                            (shareClicked)="openShareModal($event)" (subscribeClicked)="openSubscribe()"
                            (numberOfGridRows)="numGridRows = $event">
                        </cv-manage-available-dashboards>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
